import React, { FC } from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { Barcode } from '@one-thd/sui-icons';
import { setButtonEvent } from '../../utils/analytics';

interface ScanToPayButtonProps {
  onClick?: () => void;
}

const ScanToPayButton: FC<ScanToPayButtonProps> = ({ onClick }) => {
  const handleClick = () => {
    setButtonEvent('cards and accounts: gift card: scan to pay');
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className="sui-mb-8">
      <Button
        data-testid="scan-to-pay"
        fullWidth
        onClick={handleClick}
        startIcon={Barcode}
        variant="secondary"
      >
        &nbsp;Scan to Pay
      </Button>
    </div>
  );
};

ScanToPayButton.displayName = 'ScanToPayButton';

export { ScanToPayButton };
